import React from "react";

const TINTS = {
  maroon: { bg: "#8B1E2D", text: "#F4C430", intensity: 0.08 },
  gold: { bg: "#F4C430", text: "#8B1E2D", intensity: 0.14 },
  ember: { bg: "#E76F2E", text: "#FFFFFF", intensity: 0.12 },
  ink: { bg: "#1A1A1A", text: "#F4C430", intensity: 0.04 },
  cream: { bg: "#F7F3EE", text: "#8B1E2D", intensity: 1 },
};

// Solid-color placeholder block with grain overlay + optional label/index glyph
const Placeholder = ({
  tint = "maroon",
  label = "",
  index = "",
  ratio = "aspect-[4/3]",
  className = "",
  solid = false,
  showMark = true,
}) => {
  const t = TINTS[tint] || TINTS.maroon;
  const bg = solid ? t.bg : `${t.bg}${Math.round(t.intensity * 255).toString(16).padStart(2, "0")}`;
  const fg = solid ? t.text : t.bg;

  return (
    <div
      className={`relative overflow-hidden grain ${ratio} ${className}`}
      style={{ backgroundColor: bg }}
    >
      {/* Editorial corner index */}
      {showMark && index ? (
        <div
          className="absolute top-4 left-5 font-inter text-[10px] tracking-[0.3em] uppercase"
          style={{ color: fg, opacity: solid ? 0.85 : 0.6 }}
        >
          {index}
        </div>
      ) : null}

      {/* Geometric glyph */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div
          className="w-16 h-16 rounded-full border"
          style={{ borderColor: fg, opacity: solid ? 0.55 : 0.35 }}
        />
      </div>

      {/* Label */}
      {label ? (
        <div className="absolute bottom-5 left-5 right-5">
          <div
            className="font-playfair italic text-lg md:text-xl leading-tight"
            style={{ color: fg, opacity: solid ? 1 : 0.85 }}
          >
            {label}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Placeholder;
